<template>
  <div
    v-if="enabled"
    class="d-flex align-center"
  >
    <v-icon size="18">
      {{ completed ? 'check_box' : 'check_box_outline_blank' }}
    </v-icon>

    <span class="ml-2 fw-300 fs-16">
      {{ $bct(name) }}
    </span>
  </div>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  classes: {
    type: String,
    default: '',
  },
  completed: Boolean,
  enabled: Boolean,
  name: {
    type: String,
    default: '',
  },
});
</script>
